export interface WicketAdminPaginationApiResponse<T> {
  data: T[];
  total: number;
}
